module.exports = __webpack_public_path__ + "img/slide-8-3.d2306fe1.jpg";